import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';

@Component({
	selector: 'pcp-import-excel',
	templateUrl: './import-excel.component.html',
	styleUrls: ['./import-excel.component.scss'],
})
export class ImportExcelComponent implements OnInit, OnChanges {
	@Input()
	labels: LabelsInterface = {
		lbl_remover_anexo: '',
		lbl_executar_carga: '',
		lbl_importar_planilha_carga: '',
	};

	@Input()
	isUploadingExcel = false;

	@ViewChild('excelFile', { read: ElementRef }) excelFile: ElementRef;

	@Output()
	getExcelJson = new EventEmitter();

	@Input()
	cleanFile = false;

	constructor(
		public ExcelService: ExcelService,
		private LabelsService: LabelsService
	) {}

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.cleanFile && changes.cleanFile.currentValue === true) {
			this.cleanFileDom();
			setTimeout(() => {
				this.cleanFile = false;
			}, 10);
		}

		if (changes && changes.labels) {
			this.labels = changes.labels.currentValue;
		}

		if (changes && changes.isUploadingExcel) {
			this.isUploadingExcel = changes.isUploadingExcel.currentValue;
		}
	}

	importExcel(): void {
		if (this.isUploadingExcel) return;

		this.ExcelService.importExcel().then((res) => {
			this.emitGetExcelJson(res);
		});
	}

	cleanFileDom(): void {
		this.excelFile.nativeElement.value = '';
	}

	emitGetExcelJson(emit: any): void {
		this.getExcelJson.emit(emit);
	}
}
